export default __webpack_public_path__ + "static/media/logo-icon.82c02189.svg";